import type { ReactNode } from 'react';

export const symbol_location_home: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m516-813 260 195q11.25 8.25 17.63 21 6.37 12.75 6.37 27v390q0 24.75-17.62 42.37Q764.75-120 740-120H220q-24.75 0-42.37-17.63Q160-155.25 160-180v-390q0-14.25 6.38-27 6.37-12.75 17.62-21l260-195q15.68-12 35.84-12Q500-825 516-813Zm42 410.88q32-32.12 32-78T557.88-558q-32.12-32-78-32T402-557.88q-32 32.12-32 78T402.12-402q32.12 32 78 32T558-402.12Zm-113.5-42.2q-14.5-14.33-14.5-35.5 0-21.18 14.32-35.68 14.33-14.5 35.5-14.5 21.18 0 35.68 14.32 14.5 14.33 14.5 35.5 0 21.18-14.32 35.68-14.33 14.5-35.5 14.5-21.18 0-35.68-14.32ZM479-250q-55 0-106.5 18T278-180h403q-44-34-95.5-52T479-250ZM220-574v365q54-48 120.52-74.5Q407.03-310 479-310q72.67 0 139.84 27Q686-256 740-208v-366L480-763 220-574Zm260 94Z"
		/>
	</svg>
);
